import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {
  FiArrowLeft,
  FiExternalLink,
  FiHelpCircle,
  FiMail,
} = FiIcons;

export default function Support() {
  return (
    <div className="relative flex flex-grow items-center overflow-hidden px-5 py-16 sm:px-6 sm:py-20 animate-fade-in">
      <div className="hero-grid" aria-hidden="true" />

      <div className="relative mx-auto w-full max-w-3xl">
        <Link
          to="/"
          className="group mb-10 inline-flex items-center gap-2 text-sm text-gray-500 transition-colors hover:text-[#ccff00]"
        >
          <SafeIcon
            icon={FiArrowLeft}
            className="transition-transform group-hover:-translate-x-1"
          />
          Back to Home
        </Link>

        <section className="relative overflow-hidden rounded-3xl border border-white/[0.08] bg-[#080b09]/90 p-8 text-center shadow-2xl shadow-black/40 sm:p-12">
          <div
            className="absolute left-1/2 top-0 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#ccff00]/10 blur-3xl"
            aria-hidden="true"
          />

          <div className="relative">
            <div className="mx-auto mb-7 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#ccff00]/10 text-[#ccff00]">
              <SafeIcon icon={FiHelpCircle} className="text-3xl" />
            </div>

            <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-[#ccff00]">
              We’re here to help
            </p>

            <h1 className="mb-5 text-4xl font-black tracking-tight text-white sm:text-6xl">
              Support
            </h1>

            <p className="mx-auto mb-9 max-w-xl text-base leading-8 text-gray-400 sm:text-lg">
              Have a question or need help with Paddle Up? Contact our support
              team by email and we’ll get back to you as soon as possible.
            </p>

            <a
              href="mailto:paddleupcoach@gmail.com"
              className="inline-flex items-center justify-center gap-3 rounded-xl bg-[#ccff00] px-6 py-4 font-bold text-black transition hover:-translate-y-0.5 hover:bg-[#d8ff42]"
            >
              <SafeIcon icon={FiMail} className="text-xl" />
              paddleupcoach@gmail.com
              <SafeIcon icon={FiExternalLink} />
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}